<template>
  <section class="cta-banner" :class="{ 'with-products': products }">
    <div class="cta-copy">
      <h2>{{ title }}</h2>
      <p>{{ text }}</p>
      <div class="cta-actions">
        <router-link class="light-button" to="/contact_us">Get Free Quote</router-link>
        <router-link class="outline-button" to="/contact_us">{{ secondary }}</router-link>
      </div>
    </div>
    <!-- 中间优势列表 -->
      <div class="banner-features">
        <div class="feature-item">
          <span class="feature-icon">🏅</span>
          <div class="feature-text">
            <div class="feature-num">10+ Years</div>
            <div class="feature-label">Industry Experience</div>
          </div>
        </div>
        <div class="feature-item">
          <span class="feature-icon">🏭</span>
          <div class="feature-text">
            <div class="feature-num">5000M+</div>
            <div class="feature-label">US Factory</div>
          </div>
        </div>
        <div class="feature-item">
          <span class="feature-icon">📦</span>
          <div class="feature-text">
            <div class="feature-num">60,000+</div>
            <div class="feature-label">Orders Shipped Daily</div>
          </div>
        </div>
        <div class="feature-item">
          <span class="feature-icon">🌐</span>
          <div class="feature-text">
            <div class="feature-num">Worldwide</div>
            <div class="feature-label">Fufillment Network</div>
          </div>
        </div>
      </div>

      <!-- 右侧产品样机图 -->
      <div class="banner-right">
        <!-- 这里替换成你的商品图片地址 -->
        <img src="@/assets/img/abou_us_1.png" alt="Custom POD Products" class="mockup-img" />
      </div>
  </section>
</template>

<script>
export default {
  name: 'CtaBanner',
  props: {
    title: { type: String, required: true },
    text: { type: String, required: true },
    secondary: { type: String, default: 'Contact Our Team' },
    products: { type: Boolean, default: true }
  }
};
</script>
<style lang="stylus" scoped>
.vi-pod-banner
  width 100%
  background #0f3490 // 深蓝主背景色
  border-radius 16px
  overflow hidden
  padding 40px 30px
  color #fff

.banner-container
  display flex
  align-items center
  justify-content space-between
  gap 40px
  flex-wrap wrap

// 左侧文案区
.banner-left
  flex 1
  min-width 320px

.banner-title
  font-size 46px
  font-weight 700
  line-height 1.2
  margin 0 0 20px
  color #ffffff

.banner-desc
  font-size 18px
  line-height 1.7
  opacity 0.9
  margin 0 0 35px
  max-width 520px

.banner-buttons
  display flex
  gap 20px
  flex-wrap wrap

.btn-primary
  padding 18px 40px
  background #fff
  color #0f3490
  border none
  border-radius 999px
  font-size 17px
  font-weight 600
  cursor pointer
  display flex
  align-items center
  gap 10px
  transition all 0.2s
  &:hover
    opacity 0.9

.btn-outline
  padding 18px 40px
  background transparent
  color #fff
  border 1px solid rgba(255,255,255,0.6)
  border-radius 999px
  font-size 17px
  font-weight 500
  cursor pointer
  display flex
  align-items center
  gap 12px
  transition all 0.2s
  &:hover
    border-color #fff
    background rgba(255,255,255,0.08)

// 中间优势列表
.banner-features
  display flex
  flex-direction column
  gap 14px
  min-width 200px

.feature-item
  display flex
  align-items center
  gap 16px

.feature-icon
  display flex
  align-items center
  justify-content center
  font-size 22px
  flex-shrink 0

.feature-num
  font-size 18px
  font-weight 700

.feature-label
  font-size 15px
  opacity 0.85

// 右侧产品图
.banner-right
  flex-shrink 0
  width 100%

.mockup-img
  width 100%
  height auto
  display block

// 响应式适配
@media (max-width: 1400px)
  .banner-right
    width 420px
@media (max-width: 1080px)
  .banner-container
    flex-direction column
  .banner-right
    width 100%
  .banner-title
    font-size 36px
@media (max-width: 640px)
  .banner-buttons
    flex-direction column
    width 100%
  .btn-primary, .btn-outline
    width 100%
    justify-content center
  .banner-title
    font-size 28px
</style>
